import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric } from '../../shared/index';
import { DataViewMin } from './data-view-min.model';
import { DataView } from './data-view.model';
import { ProfileAdvancedSearchParams } from '../search/profile-advanced-search-params.model';

@Injectable()
export class DataViewService {
  public _apiService: ApiService;
  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  /*
    // Get dataviews suitable for a dropdown list
    */
  public getSavedDataViews = (): Promise<Array<DataViewMin>> => {
    let url: string = '/Profile/AdvancedSearch/MyDataViews';
    return this._apiService.get(url);
  };

  /*
    // Get dataviews suitable for a dropdown list
    */
  public getSavedDataView = (id: number): Promise<DataView> => {
    let url: string = '/Profile/AdvancedSearch/MyDataViews/' + id;
    return this._apiService.get(url);
  };

  /*
    // Save a DataView
    */
  public saveDataView(searchParams: ProfileAdvancedSearchParams, searchName: string, allUsers: boolean): Promise<number> {
    let url: string = '/Profile/AdvancedSearch/Save';
    let dataView: DataView = new DataView();
    dataView.SearchParamDto = JSON.stringify(searchParams);
    dataView.Descr = searchName;
    dataView.AllUsers = allUsers;
    return this._apiService.post(url, dataView);
  }

  getMySavedDataViews(searchParams: any): Promise<PagedResultGeneric<DataViewMin>> {
    let url: string = '/Profile/AdvancedSearch/MyDataViewsPaged';
    return this._apiService.get(url);
  }

  deleteDataView(id: number): Promise<void> {
    return this._apiService.delete('/profile/v2/dataView/Delete/' + id);
  }
}
